import { StyledEngineProvider } from '@mui/material/styles'

import 'assets/styles/index.scss'
import { AzureProvider, Msal, StorageType } from 'components/azure-provider'
import Environment from 'libs/environment/enviroment'
import React from 'react'
import ReactDOM from 'react-dom'
import 'reflect-metadata'
import App from 'app/container/app'
import reportWebVitals from './reportWebVitals'

// import '@fontsource/open-sans' // Defaults to weight 400
import '@fontsource/open-sans/300.css'
import '@fontsource/open-sans/400.css'
import '@fontsource/open-sans/500.css'
import '@fontsource/open-sans/600.css'
import '@fontsource/open-sans/700.css'
import '@fontsource/open-sans/800.css'

const msal = new Msal({
  clientId: Environment.string(process.env.REACT_APP_MSAL_CLIENT_ID),
  authority: Environment.string(process.env.REACT_APP_MSAL_AUTHORITY),
  redirectUri: Environment.string(process.env.REACT_APP_MSAL_REDIRECTURI),
  storage: StorageType.localStorage,
})

if (process.env.REACT_APP_DISABLE_LOGS === 'true') {
  console.log = () => {}
  console.warn = () => {}
  console.info = () => {}
  console.error = () => {}
}

ReactDOM.render(
  <React.StrictMode>
    <StyledEngineProvider injectFirst>
      <AzureProvider msalInstance={msal}>
        <App />
      </AzureProvider>
    </StyledEngineProvider>
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
